'use client'

import React, { useEffect, useRef, useState } from 'react'

interface Props {
  children: [React.ReactNode, React.ReactNode]
}

export function AboutUsContactCards({ children }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry?.isIntersecting) { setVisible(true); observer.disconnect() } },
      { threshold: 0.2 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const spring = 'cubic-bezier(0.34, 1.56, 0.64, 1)'

  return (
    <div ref={ref} className="grid grid-cols-1 gap-[20px] sm:grid-cols-2 md:w-full  sm:gap-5 overflow-x-hidden">
      <div
        style={{
          transform: visible ? 'translateX(0)' : 'translateX(-120px)',
          opacity: visible ? 1 : 0,
          transition: `transform 700ms ${spring}, opacity 400ms ease-out`,
        }}
      >
        {children[0]}
      </div>
      <div
        style={{
          transform: visible ? 'translateX(0)' : 'translateX(120px)',
          opacity: visible ? 1 : 0,
          transition: `transform 700ms ${spring} 80ms, opacity 400ms ease-out 80ms`,
        }}
      >
        {children[1]}
      </div>
    </div>
  )
}
